import { commitMutation, ConnectionHandler } from "relay-runtime"
import {
  Ch_createOrReuseEpisodeOfCareInput,
  chCreateOrReuseEpisodeOfCareMutation,
  chCreateOrReuseEpisodeOfCareMutation$data,
} from "@/modules/patients/services/ch/__generated__/chCreateOrReuseEpisodeOfCareMutation.graphql"
import { chCreateOrReuseEpisodeOfCareMutation as chMutation } from "@/modules/patients/services/ch/chCreateOrReuseEpisodeOfCareMutation"
import {
  De_createOrReuseEpisodeOfCareInput,
  deCreateOrReuseEpisodeOfCareMutation,
  deCreateOrReuseEpisodeOfCareMutation$data,
} from "@/modules/patients/services/de/__generated__/deCreateOrReuseEpisodeOfCareMutation.graphql"
import { deCreateOrReuseEpisodeOfCareMutation as deMutation } from "@/modules/patients/services/de/deCreateOrReuseEpisodeOfCareMutation"
import { RelayEnvironment } from "@/relay-environment"
import { Country } from "@/types/__generated__/union-types"

export const createOrReuseEpisodeOfCare = (
  country: Country,
  input: De_createOrReuseEpisodeOfCareInput & Ch_createOrReuseEpisodeOfCareInput,
  onCompleted?: (
    episodeOfCare?:
      | chCreateOrReuseEpisodeOfCareMutation$data["createOrReuseEpisodeOfCare"]["episodeOfCare"]
      | deCreateOrReuseEpisodeOfCareMutation$data["createOrReuseEpisodeOfCare"]["episodeOfCare"]
      | null,
  ) => void,
) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const rootEpisodeOfCareConnectionId = ConnectionHandler.getConnectionID(
    "client:root",
    "RootEpisodesOfCareConnection_patientEpisodesOfCare",
    { patientId: input.patientId },
  )

  commitMutation<chCreateOrReuseEpisodeOfCareMutation | deCreateOrReuseEpisodeOfCareMutation>(RelayEnvironment, {
    mutation: mutation,
    variables: {
      input,
      addConnections: [rootEpisodeOfCareConnectionId],
    },
    onCompleted(response) {
      onCompleted?.(response.createOrReuseEpisodeOfCare.episodeOfCare)
    },
  })
}
